export const SET_LOCALE = "SET_LOCALE";



// WEBPACK FOOTER //
// ./src/components/intl/intlActionTypes.js